import AnswerSection from './node-answer-section';
import ListItem from './node-list-item';
import RomanList from './node-roman-list';
import AlphabetList from './node-alphabet-list';
import Tables from './node-table';
import LangEnglish from './node-language-english';
import LangMalay from './node-language-malay';
import Image from './node-image';
import AnswerSpace from './node-answer-space';
import Paragraph from './node-parapraph';

export const NodeTypes = {
  // NOTE: our own node
  AnswerSection: AnswerSection.type,
  RomanList: RomanList.type,
  AlphabetList: AlphabetList.type,
  ListItem: ListItem.type,
  LangEnglish: LangEnglish.type,
  LangMalay: LangMalay.type,
  AnswerSpace: AnswerSpace.type,
  Paragraph: Paragraph.type,

  // NOTE: titap node
  Doc: 'doc',
  Text: 'text',
  Table: 'table',
  BulletList: 'bulletList',
  // OrderedList: 'orderedList',
  OrderedList: '',
  image: 'image',
};

export default [
  AnswerSection.node,
  RomanList.node,
  AlphabetList.node,
  ListItem.node,
  LangEnglish.node,
  LangMalay.node,
  AnswerSpace.node,
  Paragraph.node,
  Image,
  ...Tables,
];
